import React, {useState, useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {getPromoterService} from "../../../../services/getPromoterService";
import {getOrder, getOrderFromPendingPaymentId, postCreateTransaction} from "../../../../services/orderService";
import Loader from "../../../../components/Loader/Loader";
import Header from "../Header/Header";
import Footer from "../../../../components/Footer";
import OrderDetails from "../order/OrderDetails";
import Breadcrumbs from "../../../../components/Checkout/Breadcrumbs/BreadCrumbs";
import MercadoPago from "./MercadoPago";
import {Helmet, HelmetProvider} from "react-helmet-async";
import Transferencia from "./Transferencia";
import Bank from "./Bank";
import Cash from "./Cash";
import useDataTravel from '../../../../hooks/useDataTravel';
import MetaTags from "../../../../components/MetaTags";

const Payments = () => {
    const currentStep = 2;

    const [promoter, setPromoter] = useState(null);
    const [loading, setLoading] = useState(true);
    const [order, setOrder] = useState(null);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [isReservation, setIsReservation] = useState(false);
    const [isPending, setIsPending] = useState(false)
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [paymentProvider, setPaymentProvider] = useState("");
    const [isFormValid, setIsFormValid] = useState(false);
    const [haveTime, setHaveTime] = useState(false)
    const [localTravelData, setLocalTravelData] = useState(null);

    const { fetchData } = useDataTravel();

    useEffect(() => {
        const fetchPromoter = async () => {
            try {
                const data = await getPromoterService();
                setPromoter(data);
                let order;
                if (searchParams.get("payment_id")) {
                    order = await getOrderFromPendingPaymentId(searchParams.get("payment_id"));
                    setIsPending(true)
                } else {
                    order = await getOrder();
                    setIsReservation(order.booking.quotation.is_reservation);
                    setIsPending(false)
                }
                setOrder(order);
                setHaveTime(order.booking.quotation.has_available_time_spots)

                const _travelData = await fetchData(order.booking.quotation.public_id);
                setLocalTravelData(_travelData);

                //console.log(order)
                if (!order.payment) {
                    // TODO: Replace using TOAST or MODAL
                    //window.alert('Payment not found!');
                    navigate('/');
                }
                // check that the payment exists, if not send to billing
                setLoading(false);
            } catch (e) {
                //console.log(e);
                // TODO: Replace using TOAST or MODAL
                //window.alert("Order not found!");
                //if (!searchParams.get("payment_id")) localStorage.removeItem("tp_order_id")
                navigate("/");
            }
        };
        fetchPromoter();
    }, [navigate, searchParams, fetchData]);

    useEffect(() => {
        setIsSmallScreen(window.innerWidth <= 800);

        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 800);
        };
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [isSmallScreen]);

    useEffect(() => {
        const formValid = paymentProvider && paymentProvider !== "mercadopago"
        setIsFormValid(formValid);
    }, [paymentProvider]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (isFormValid) {
            setLoading(true);
            try {
                await postCreateTransaction(order.payment.public_id, paymentProvider)
                navigate("/checkout/enjoy?external_reference=" + order.payment.public_id);
            } catch (e) {
                console.log(e);
                // TODO: Replace using TOAST or MODAL
                window.alert("There was a problem with the server!");
                setLoading(false);
            }
        }
    };

    if (loading) return <Loader/>;

    const currentUrl = window.location.protocol + "//" + window.location.host +  window.location.pathname + window.location.search

    return (
        <HelmetProvider>
            <MetaTags
                name={promoter.fullname}
                description={order?.booking?.quotation?.itinerary?.description}
                icon={promoter.logoURL}
                title={order?.booking?.quotation?.title}
                url={currentUrl}
                font={localTravelData.data.font ? localTravelData.data.font : null}
                primaryColor={localTravelData.data.colors.primary_color ? localTravelData.data.colors.primary_color : null}
                secondaryColor={localTravelData.data.colors.secondary_color ? localTravelData.data.colors.secondary_color : null}
            />
            <Header promoter={promoter}></Header>
            <div className="payments__container">
                <Breadcrumbs currentStep={currentStep} noGoBack={isPending}></Breadcrumbs>
                <div className="main-content">
                    <div className="payments-details__container">
                        <MercadoPago order={order}></MercadoPago>
                        <Transferencia setPaymentProvider={setPaymentProvider} paymentProvider={paymentProvider}></Transferencia>
                        <Bank setPaymentProvider={setPaymentProvider} paymentProvider={paymentProvider}></Bank>

                    </div>
                    <OrderDetails
                        numPassengers={order.passengers.length}
                        quotation={order.booking.quotation}
                        passengers={order.passengers}
                        isReservation={isReservation}
                        isPending={isPending}
                        payment={order.payment ? order.payment : {}}
                        isSmallScreen={isSmallScreen}
                        nextStepLabel={isPending ? 'Pagar' : 'Reservar'}
                        isFormValid={isFormValid}
                        handleSubmitNextStep={handleSubmit}
                        selectDate={order.booking.selected_date ? order.booking.selected_date : ''}
                        haveTime={haveTime}
                        selectedOption={order.booking.selected_option ? order.booking.selected_option : ''}
                    />
                </div>
                {!isSmallScreen && (
                    <div className="checkout-actions">
                        <button type="button" onClick={handleSubmit} disabled={!isFormValid}>
                            {isPending ? 'Pagar' : 'Reservar'}
                        </button>
                    </div>
                )}
            </div>
            <Footer promoter={promoter}></Footer>
        </HelmetProvider>
    );
};

export default Payments;
